//ProjectData.js
export const initialProjects = [
  {
    name: "REACTION DIFFUSION",
    image: process.env.PUBLIC_URL + "/ReactionDiffusion.png",
    date: "06/10/2024",
    route: "/UnderMaintenance"
  },
  {
    name: "GLYPHS",
    image: process.env.PUBLIC_URL + "/Blocks.jpg",
    date: "05/04/2025",
    route: "/glyphs"
  },
  {
    name: "SINGLE LINE",
    image: process.env.PUBLIC_URL + "/SingleLine.jpg",
    date: "04/30/2024",
    route: "/WorkInProgress"
  },
  {
    name: "HALFTONES",
    image: process.env.PUBLIC_URL + "/Halftones.jpg",
    date: "07/19/2025",
    route: "/halftones"
  },
  {
    name: "BOIDS",
    image: process.env.PUBLIC_URL + "/BOIDS.png",
    date: "07/20/2025",
    route: "/boids"
  },
  {
    name: "VORONOI",
    image: process.env.PUBLIC_URL + "/Giraffe.png",
    date: "09/14/2025",
    route: "/voronoi"
  },
  {
    name: "SUPERPIXELS",
    image: process.env.PUBLIC_URL + "/GmaPainting.jpg",
    date: "09/15/2025",
    route: "/superpixels"
  },
];
